// extracted by mini-css-extract-plugin
export default {"cards":"About_cards__NWrKd","card":"About_card__TCG5u"};